import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; // Importation
import getBaseUrl from '../helpers/utility';

const EditBrigade = () => {
  const { id } = useParams(); // Récupère l'ID de la brigade à partir de l'URL
  const baseUrl = getBaseUrl();
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  let token = localStorage.getItem('accessToken');

  const [brigadeData, setBrigadeData] = useState({
    name: '',
    libelle: '',
    historique: '',
    observation: '',
    reference: '',
    implantation: '',
    filename: null,
    chefDeBrigade: '',
    personnelId: null,
  });
  const [newImage, setNewImage] = useState(null);
  const [removeImage, setRemoveImage] = useState(false); // Pour gérer la suppression de l'image existante
  const [error, setError] = useState(''); // Pour gérer la suppression de l'image existante

  const handleRemoveImage = () => {
    setBrigadeData({ ...brigadeData, filename: '' });
    setRemoveImage(true); // Indiquer que l'image existante doit être supprimée
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(file);
      setImagePreview(URL.createObjectURL(file));
      setBrigadeData((prevData) => ({ ...prevData, filename: file.name }));
    }
    setRemoveImage(false);
  };

  const [personnelSuggestions, setPersonnelSuggestions] = useState([]);

  useEffect(() => {
    const fetchBrigade = async () => {
      try {
        const response = await axios.get(`brigade/show/${id}`);
        //setBrigadeData(response.data);
        const brigadeData = response.data;

        setBrigadeData({
          ...brigadeData,
          name: brigadeData.name || null,
          libelle: brigadeData.libelle || null,
          historique: brigadeData.historique || null,
          observation: brigadeData.observation || null,
          reference: brigadeData.reference || null,
          implantation: brigadeData.implantation || null,
          filename: brigadeData.filename || null,
          personnelId: brigadeData.personnelId || null,
          chefDeBrigade: brigadeData.personnel ? brigadeData.personnel.nomprenom : null,
        });

        if (brigadeData.personnelId) {
          const personnelResponse = await axios.get(`personnel/show/${brigadeData.personnelId}`);
          setBrigadeData({
            ...brigadeData,
            chefDeBrigade: personnelResponse.data.nomprenom || null,
          });
        }
      } catch (error) {
        console.error('Voir > EditBrigade.js eseEffect() du route brigade api/id/show/ :', error);
      }
    };
    fetchBrigade();
  }, []);

  // Fetch personnel suggestions based on input
  const handleChefDeBrigadeChange = async (e) => {
    console.log(e);
    const query = e.target.value.toLowerCase().trim();

    setBrigadeData({
      ...brigadeData,
      chefDeBrigade: e.target.value,
    });

    if (query.length >= 1) {
      try {
        const res = await axios.get(`personnel/`, {
          params: {
            nomprenom: query,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        console.log(res.data);
        //const limitResult = res.data.slice(0, 10)
        const filtreResultat = res.data
          .filter((personnel) => {
            const nomComplet = (personnel.nomprenom || '').toLowerCase();
            return query.split(' ').every((term) => nomComplet.includes(term));
          })
          .slice(0, 10);
        setPersonnelSuggestions(filtreResultat);
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions de personnels', error);
      }
    } else {
      setPersonnelSuggestions([]);
      setBrigadeData({
        ...brigadeData,
        chefDeBrigade: null,
        personnelId: null,
      });
    }
  };

  // Handle personnel selection
  const handlePersonnelSelect = (personnel) => {
    setBrigadeData({
      ...brigadeData,
      chefDeBrigade: personnel.nomprenom,
      personnelId: personnel.id,
    });
    setPersonnelSuggestions([]);
  };

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBrigadeData({ ...brigadeData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    const updatedBrigadeData = { ...brigadeData };

    if (newImage) {
      const fixedImageName = `${brigadeData.name}_${newImage.name}`;
      updatedBrigadeData.filename = fixedImageName;
      formData.append('file', newImage, fixedImageName);
    } else if (removeImage) {
      updatedBrigadeData.filename = null;
      formData.append('removeImage', true);
    }

    formData.append('brigadeData', JSON.stringify(updatedBrigadeData));

    try {
      const response = await axios.put(`brigade/${id}/edit`, formData);

      if (response.data.success) {
        toast.success('Enregistrement Brigade avec succès !', {
          position: 'bottom-right',
        });
        setTimeout(() => {
          navigate('/brigade');
        }, 2000);
      }
    } catch (error) {
      setError(error.response.data.error);
      toast.error("Erreur lors de l'enregistrement", {
        position: 'bottom-right',
      });
    }
  };

  useEffect(() => {
    return () => {
      if (imagePreview) URL.revokeObjectURL(imagePreview);
    };
  }, [imagePreview]);

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h2 className="text-2xl font-semibold text-gray-900 mb-6">Modifier la Brigade</h2>

      {error && (
        <div className="mb-6 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <form
        encType="multipart/form-data"
        onSubmit={handleSubmit}
        className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 space-y-8"
      >
        {/* Infos générales */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div>
            <label htmlFor="libelle" className="block text-sm font-medium text-gray-700 mb-1.5">
              Libellé
            </label>
            <input
              type="text"
              id="libelle"
              name="libelle"
              value={brigadeData.libelle}
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
            />
          </div>
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1.5">
              Nom
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={brigadeData.name}
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
            />
          </div>
          <div>
            <label htmlFor="historique" className="block text-sm font-medium text-gray-700 mb-1.5">
              Historique
            </label>
            <textarea
              id="historique"
              name="historique"
              rows={3}
              value={brigadeData.historique}
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition resize-none"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div>
            <label htmlFor="observation" className="block text-sm font-medium text-gray-700 mb-1.5">
              Observation
            </label>
            <textarea
              id="observation"
              name="observation"
              rows={3}
              value={brigadeData.observation}
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition resize-none"
            />
          </div>
          <div>
            <label htmlFor="reference" className="block text-sm font-medium text-gray-700 mb-1.5">
              Référence
            </label>
            <input
              type="text"
              id="reference"
              name="reference"
              value={brigadeData.reference}
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
            />
          </div>
          <div>
            <label htmlFor="implantation" className="block text-sm font-medium text-gray-700 mb-1.5">
              Implantation
            </label>
            <input
              type="text"
              id="implantation"
              name="implantation"
              value={brigadeData.implantation}
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
            />
          </div>
        </div>

        {/* Chef de brigade avec autocomplete */}
        <div className="relative">
          <label htmlFor="chefDeBrigade" className="block text-sm font-medium text-gray-700 mb-1.5">
            Chef de Brigade
          </label>
          <input
            type="text"
            id="chefDeBrigade"
            name="chefDeBrigade"
            value={brigadeData.chefDeBrigade}
            onChange={handleChefDeBrigadeChange}
            placeholder="Entrez le nom du chef de brigade"
            className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
          />

          {personnelSuggestions.length > 0 && (
            <ul className="absolute z-10 mt-1.5 w-full max-h-56 overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg">
              {personnelSuggestions.map((personnel) => (
                <li
                  key={personnel.id}
                  onClick={() => handlePersonnelSelect(personnel)}
                  className="px-4 py-2.5 text-sm text-gray-700 cursor-pointer hover:bg-indigo-50 hover:text-indigo-700 transition"
                >
                  {personnel.nomprenom}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Image */}
        <div>
          <label htmlFor="image" className="block text-sm font-medium text-gray-700 mb-1.5">
            Image de la Brigade
          </label>

          <div className="flex flex-col sm:flex-row sm:items-start gap-5">
            <div className="relative shrink-0">
              <img
                src={imagePreview || `${baseUrl}/images/brigades/${brigadeData.filename}`}
                alt="Brigade"
                className="w-48 h-32 object-cover rounded-lg border border-gray-200"
              />
              <button
                type="button"
                onClick={handleRemoveImage}
                aria-label="Supprimer l'image"
                className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-red-500 hover:bg-red-50 hover:border-red-200 transition"
              >
                <i className="fa fa-trash text-xs"></i>
              </button>
            </div>

            <input
              type="file"
              id="image"
              name="file"
              onChange={handleImageChange}
              className="block w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer"
            />
          </div>
        </div>

        <div className="flex justify-end pt-2">
          <button
            type="submit"
            className="inline-flex items-center rounded-lg bg-indigo-600 px-5 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition"
          >
            Enregistrer les modifications
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditBrigade;
